import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Hooks
import useAuth from "utils/hooks/useAuth";

// Ability
import { AbilityContext, Subjects } from "context/Ability";
import { useAbility } from "@casl/react";

const useRedirectOnNoAdminPermission = (permission: Subjects, navigateTo: string) => {
    const { hasSession } = useAuth();
    const navigate = useNavigate();

    const ability = useAbility(AbilityContext);
    const canSeeCurrentPage = ability.can("see", permission);

    useEffect(() => {
        if (hasSession && !canSeeCurrentPage) {
            navigate(navigateTo);
        }
    }, [hasSession, canSeeCurrentPage, navigateTo, navigate]);
};

export default useRedirectOnNoAdminPermission;
